import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "../ui/select";

const GROUPS = [["client", "Sent to clients"], ["staff", "Sent to the Medicys team"]];

export function EmailPicker({ emails, selected, onSelect }) {
  const current = emails.find((e) => e.kind === selected);
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3" data-testid="sow-emails-picker-row">
      <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500">Email</span>
      <Select value={selected || ""} onValueChange={onSelect}>
        <SelectTrigger className="w-full sm:w-[460px] bg-white" data-testid="sow-email-picker">
          <SelectValue placeholder="Choose an email" />
        </SelectTrigger>
        <SelectContent>
          {GROUPS.map(([group, label]) => (
            <SelectGroup key={group}>
              <SelectLabel className="font-mono text-[10px] tracking-[0.2em] uppercase text-stone-500">{label}</SelectLabel>
              {emails.filter((e) => e.group === group).map((e) => (
                <SelectItem key={e.kind} value={e.kind} data-testid={`sow-email-option-${e.kind}`}>
                  {e.label}{e.template?.customised ? " · edited" : ""}
                </SelectItem>
              ))}
            </SelectGroup>
          ))}
        </SelectContent>
      </Select>
      {current?.template?.customised && (
        <span className="text-[10px] font-mono uppercase tracking-wider text-amber-700" data-testid={`sow-email-customised-${current.kind}`}>Edited</span>
      )}
    </div>
  );
}
